import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { designConstants as design } from 'styles/designConstants';

interface IProps {
  width?: number;
  height?: number;
  top?: string;
  left?: string;
  wrapperWidth?: number;
  wrapperHeight?: number;
}

const useStyles = makeStyles({
  wrapper: (props: IProps) => ({
    position: 'relative',
    height: props.wrapperHeight ? `${props.wrapperHeight}px` : '200px',
    width: props.wrapperWidth || '',
  }),
  progress: (props: IProps) => ({
    color: `rgba(${design.color.$teal_base}, 1)`,
    position: 'absolute',
    top: props.top ? props.top : '50%',
    left: props.left ? props.left : '50%',
    height: props.height ? `${props.height}px` : '200px',
    width: props.width || '',
  }),
});

const CircularLoader = (props: IProps) => {
  const classes = useStyles(props);

  return (
    <div className={classes.wrapper} data-testid="circular-loader">
      <CircularProgress
        className={classes.progress}
        size={props.height || 40}
      />
    </div>
  );
};

export default CircularLoader;
